import React from "react"
import Switch from "react-switch"

const ThrottleSwitch = ({ throttled, requestLoading, handleToggleRequest, pendingMessage }) => (
  <div style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }}>

    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <label htmlFor="material-switch">
        unthrottle
      </label>
      <div style={{ margin: "1rem 1rem" }}>
        <Switch
          disabled={requestLoading ? true : null}
          checked={throttled}
          onChange={handleToggleRequest}
          onColor="#e74c3c5e"
          onHandleColor="#e74c3c"
          handleDiameter={30}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={48}
          className="react-switch"
          id="material-switch"
        />
      </div>
      <label htmlFor="material-switch">
        throttle
      </label>
    </div>

    <div style={{color: "red"}}>{pendingMessage}</div>
  </div>
)

export default ThrottleSwitch
